export const parseClient = client => {
	let templates = client.templates;
	if (!Array.isArray(templates)) {
		if (!client.templates || client.templates === '') templates = [];
		else templates = JSON.parse(templates);
	}
	return {
		...client,
		templates,
	};
};

export const getAdminClients = props => {
	const { admins, adminSSOProfile, isSuperAdmin, clients } = props;
	const { email } = adminSSOProfile;
	const adminPermissions = admins[email];
	let validClients = [];
	if (adminPermissions && Object.keys(adminPermissions).length) {
		const adminClientIDs = adminPermissions.clients.reduce((accum, client) => {
			accum[client.id] = client;
			return accum;
		}, {});

		const adminEventClientIDs = adminPermissions.events.reduce((accum, event) => {
			accum[event.client_id] = event;
			return accum;
		}, {});

		const adminRolesClientIDs = adminPermissions.perms.reduce((accum, role) => {
			accum[role.event.client_id] = role.event;
			return accum;
		}, {});

		validClients = clients.filter(client => {
			return (
				isSuperAdmin ||
				adminClientIDs[client.id] ||
				adminEventClientIDs[client.id] ||
				adminRolesClientIDs[client.id]
			);
		});
	}
	return validClients;
};
